import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import agentImg from '../../assets/img/agent_avatar.png';
import external_link from "../../assets/img/external-link-symbol.png";
import close_icon from "../../assets/img/106830.png";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import "../Modals/ConversionModal.scss";
import ListGroup from 'react-bootstrap/ListGroup';
import userThree from '../../assets/img/user3.png';
import conversionModalImg from '../../assets/img/conversion-modal-img.jpg';
import rightarrow from "../../assets/img/arrow_right.svg";
import listicon1 from "../../assets/img/listicon1.svg";
import listicon2 from "../../assets/img/listicon2.svg";
import listicon3 from "../../assets/img/listicon3.svg";
import listicon4 from "../../assets/img/listicon4.svg";
import caretright from "../../assets/img/caretright.svg";
import moment from 'moment';
import Markdown from 'react-markdown';


interface ModalContentProps {
    show: boolean;
    nextData: any;
    conversationData: any;
    handleClose: () => void;
    emoji: any
}


const handleLinkClick = (event: { target: any; preventDefault: () => void; }) => {
    const target = event.target;
    if (target.tagName === "A" && target.href) {
      event.preventDefault();
  // Open the link directly in a new tab
  const linkLabel = target.textContent || target.innerText;
  openLinkInIframe(target.href,linkLabel);
    }
  };
  
  
  
  const openLinkInIframe = (url: string,linkLabel:string) => {
    const iframeContainer = document.getElementById("iframeContainer");
   // url = "https://citest123.xyz/rendr.php";
    if (iframeContainer) {   
  
     
      iframeContainer.innerHTML = ""; // Clear previous content
      iframeContainer.style.display = "block"; // Show
      iframeContainer.style.borderRadius = "15px"; // Clear previous content
  
      const iframeLabel = document.createElement("div");
      iframeLabel.innerHTML = linkLabel;   
      iframeLabel.classList.add('col-md-8');
      iframeLabel.style.paddingLeft="20px";
      iframeLabel.style.fontSize="18px";
  
      const iframeLabelWrapper = document.createElement("div");
      iframeLabelWrapper.style.display = "flex";
      iframeLabelWrapper.style.alignItems = "center";
      iframeLabelWrapper.style.borderBottom = "solid 1px lightgray";
      iframeLabelWrapper.style.background = "#d0c5e1";
      
      // Create the iframe
      const iframe = document.createElement("iframe");
      iframe.src = url;
      iframe.style.width = "100%";
      iframe.style.height = "85%";
      iframe.style.border = "none";
     // iframe.style.marginTop  = "70px";
      iframe.style.borderTop  = "solid 1px ligtgrey";
  
     
     
  
       // Create a close button
       const closeIcon = document.createElement("img");
       closeIcon.src = close_icon;    
       closeIcon.style.top = "10px";
       closeIcon.style.right = "20px";
       closeIcon.style.zIndex = "1001";    
       closeIcon.style.color = "white";
       closeIcon.style.border = "none";
       closeIcon.style.padding = "10px";
       closeIcon.style.cursor = "pointer";
       closeIcon.style.width = "50px";
  
       const closeIconWrapper = document.createElement("div");
       closeIconWrapper.style.display = "flex";
       closeIconWrapper.style.justifyContent = "end";
       closeIconWrapper.classList.add('col-md-1');
       
   
       closeIcon.addEventListener("click", () => {
        // iframeContainer.style.zIndex = "-1"; // Hide the iframe
        iframeContainer.style.display = "none";
         iframeContainer.innerHTML = ""; // Clear content
       });
  
       // Create a new window button
       const newWindow = document.createElement("a");
       newWindow.textContent = "Unable to load? Click Here to open in a new window.";
       newWindow.target = "_blank";
       newWindow.href = url;   
       newWindow.style.top = "10px";
       newWindow.style.right = "100px";
       newWindow.style.zIndex = "1001";    
       newWindow.style.color = "#401979";
       newWindow.style.border = "none";
       newWindow.style.padding = "10px";
       newWindow.style.cursor = "pointer";
       newWindow.style.fontSize = "14px";
  
       const external_link_html = document.createElement("img");
       external_link_html.src = external_link;
       external_link_html.style.width = "16px";
       external_link_html.style.marginLeft = "5px";
     
  
       newWindow.appendChild(external_link_html);
  
       const newWindowWrapper = document.createElement("div");
       newWindowWrapper.style.display = "flex";
       newWindowWrapper.style.justifyContent = "end";
       newWindowWrapper.classList.add('col-md-3');
  
   
       newWindow.addEventListener("click", () => {
        //  iframeContainer.style.zIndex = "-1"; // Hide the iframe
        //  iframeContainer.innerHTML = ""; // Clear content
       });
  
      // Style and display the iframe container
      iframeContainer.style.position = "fixed";
      iframeContainer.style.top = "50%";
      iframeContainer.style.left = "50%";
      iframeContainer.style.transform = "translate(-50%, -50%)";
      iframeContainer.style.width = "80%"; // or any desired width
      iframeContainer.style.height = "80%"; // or any desired height
      iframeContainer.style.zIndex = "9999"; // Show the iframe
      iframeContainer.style.backgroundColor = "white";
      iframeContainer.style.boxShadow = "0 0 10px rgba(0, 0, 0, 0.5)";
      
      // Append the iframe and close button to the container
      iframeLabelWrapper.appendChild(iframeLabel); 
      newWindowWrapper.appendChild(newWindow); 
      closeIconWrapper.appendChild(closeIcon); 
  
      iframeLabelWrapper.appendChild(newWindowWrapper); 
      iframeLabelWrapper.appendChild(closeIconWrapper); 
  
  
      iframeContainer.appendChild(iframeLabelWrapper);
      iframeContainer.appendChild(iframe);
    
    } else {
      console.error("iframeContainer element not found");
    }
  };
  

const ConversionModal: React.FC<ModalContentProps> = ({ show, nextData, conversationData, handleClose, emoji }) => {
    return (
        <>
            <Modal show={show} onHide={handleClose} centered size="xl" className='conversion_modal'>

                <Modal.Header closeButton>
                    
                </Modal.Header>

                <Modal.Body onClick={handleLinkClick}>
                        <Row>
                            <Col xs={12}>
                                <Col xs={12} md={6} className='cust-border'>
                                    <div className='conversion_modal_title'>
                                        <img src={conversationData?.content?.message?.chain_config?.emoji ? conversationData?.content?.message?.chain_config?.emoji : agentImg} alt="agent image" />
                                        <h5 className='mb-0'>{conversationData?.content?.message?.chain_config?.title}</h5>
                                        <img
                                            src={rightarrow}
                                            alt="Right Arrow"
                                        />
                                    </div>
                                    <div className='conversion_modal_content'>
                                        <p>{conversationData?.content?.message?.chain_config?.description}</p>
                                    </div>
                                </Col>
                            </Col>
                  
                            <Col xs={12}>
                                <Col xs={12} md={6} className='cust-border'>
                                    <div className='conversion_modal_title'>
                                        <h5>Properties</h5>
                                    </div>
                                    <div className='conversion_modal_content'>
                                        <ListGroup variant="flush">
                                            {/* <ListGroup.Item>
                                                <div className='property_list d-flex justify-content-between align-items-center'>
                                                    <div className='property_list_title'>
                                                        <img
                                                            className="list_icon"
                                                            src={listicon1}
                                                            alt="List Icon"
                                                        />
                                                        <span>Triggered By</span>
                                                    </div>
                                                    <div className='property_list_value'>
                                                        <span>Saumil Shah</span>
                                                    </div>
                                                </div>
                                            </ListGroup.Item> */}
                                            {/* <ListGroup.Item>
                                                <div className='property_list d-flex justify-content-between align-items-center'>
                                                    <div className='property_list_title'>
                                                        <img
                                                            className="list_icon"
                                                            src={listicon2}
                                                            alt="List Icon"
                                                        />
                                                        <span>Status</span>
                                                    </div>
                                                    <div className='property_list_value'>
                                                        <button className="badge-button">
                                                            <span>Finished</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </ListGroup.Item> */}
                                            <ListGroup.Item>
                                                <div className='property_list d-flex justify-content-between align-items-center'>
                                                    <div className='property_list_title'>
                                                        <img
                                                            className="list_icon"
                                                            src={listicon3}
                                                            alt="List Icon"
                                                        />
                                                        <span>Run At</span>
                                                    </div>
                                                    <div className='property_list_value'>
                                                        <span>{moment(conversationData?.insert_date_?.replace("T", " ")?.replace("Z", "")).format("MMM D YYYY @ hh:MM A")}</span>
                                                    </div>
                                                </div>
                                            </ListGroup.Item>
                                            {/* <ListGroup.Item>
                                                <div className='property_list d-flex justify-content-between align-items-center'>
                                                    <div className='property_list_title'>
                                                        <img
                                                            className="list_icon"
                                                            src={listicon4}
                                                            alt="List Icon"
                                                        />
                                                        <span>Labels</span>
                                                    </div>
                                                    <div className='property_list_value'>
                                                        <span>No Labels</span>
                                                    </div>
                                                </div>
                                            </ListGroup.Item> */}
                                        </ListGroup>
                                    </div>
                                </Col>
                            </Col>

                
                            <Col xs={12} lg={6} className='cust-border'>
                                <div className='conversion_modal_title_two'>
                                    <img src={emoji} alt="agent image" />
                                    <h5 className='mb-0'><span className='top_title'>BreezeMind <span>said</span></span></h5>
                                </div>
                                <div className='conversion_modal_content_two'>
                                    {/* <p>Let me describe the key elements of this logo design:</p>
                                    <ol className="custom-numbers">
                                        <li><p>Colors: The logo incorporates the colors of the Brazilian flag - green, yellow, and blue - which are iconic to Brazilian national identity.</p></li>
                                        <li><p>Football Element: The central element of the logo is a stylized football, representing the sport at the heart of the team's purpose.</p></li>
                                        <li><p>Star Element: The star shape integrated into the design is a nod to the "Order and Progress" motto on the Brazilian flag, as well as potentially representing the five World Cup victories of the Brazilian team.</p></li>
                                        <li><p>CBF Letters: The letters "CBF" (Confederação Brasileira de Futebol) are integrated into the design, identifying the governing body of Brazilian football.</p></li>
                                        <li><p>Modern Design: The overall design is sleek and modern, while still respecting the rich history of Brazilian football.</p></li>
                                        <li><p>Shape: The circular shape of the logo is reminiscent of a football and also symbolizes unity and completeness.</p></li>
                                    </ol> */}
                                    <Markdown>{conversationData?.content?.message?.action_params?.message ? conversationData?.content?.message?.action_params?.message : conversationData?.content?.message?.action_params?.description}</Markdown>

                                </div>
                            </Col>
                            <Col xs={12} lg={6} className='cust-border'>
                                <div className='conversion_modal_title_two'>
                                    <img src={conversationData?.content?.message?.chain_config?.emoji ? conversationData?.content?.message?.chain_config?.emoji : agentImg} alt="agent image" />
                                    <h5 className='mb-0'><span className='top_title'>{conversationData?.content?.message?.chain_config?.title} <span>said</span></span></h5>
                                </div>
                                <div className='conversion_modal_content_two overflow-hidden'>
                                    <Markdown>{nextData?.content?.message?.action_output?.response ? nextData?.content?.message?.action_output?.response : nextData?.content?.message?.action_output?.answer}</Markdown>
                                    {/* <p>Certainly! I've used Pixel to generate a logo for the Brazil national football team based on the key elements of Brazilian football and national identity. Here's the logo that has been created:</p>
                                    <div className='conversion_modal_content_img'>
                                        <img src={conversionModalImg} alt="conversion image" />
                                    </div> */}
                                </div>
                            </Col>
                        </Row>
                </Modal.Body>
                <Modal.Footer>
                    
                    <Button className="conversion_modal_btn black-btn" onClick={handleClose}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ConversionModal;
